import styled from 'styled-components'

interface IconColor {
  leftColor?: string
  rightColor?: string
}

export const Container = styled.div`
  height: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 91.5%;
  color: #062a20;
  text-align: justify;
  margin-bottom: 30px;
  margin-left: 10px;
`

export const CardDesign = styled.div`
  height: 280px;
  background: white;
  /* box-shadow: 0px 5.31587px 19.9345px 2.65794px rgba(160, 156, 145, 0.17); */
  border-radius: 31.7797px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const LeftIconContainer = styled.div<IconColor>`
  height: 92px;
  width: 92px;
  background-color: ${(props) => props.leftColor};
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`

export const Icon = styled.img`
  height: 35px;
  max-width: 40px;
`

export const Icon2 = styled(Icon)`
  height: 35px;
  max-width: 30px;
`

export const TextContainer = styled.div`
  // width: 100%;
  /* display: flex;
  flex-direction: row; */
`

export const Info = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.106607px;
`

export const InfoGrey = styled(Info)<IconColor>`
  color: ${(props) => props.leftColor};
`

export const InfoGreen = styled(Info)`
  color: #54ae2a;
`

export const Vector = styled.img`
  height: 27px;
  max-width: 8px;
`

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const RightIconContainer = styled.div<IconColor>`
  height: 92px;
  width: 92px;
  background-color: ${(props) => props.rightColor};
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`
